import React, { Component } from 'react'
import { Form, Input, DatePicker, Modal, Button, TimePicker, Select, Icon } from 'antd'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import queryString from 'query-string'
import { formItemLayout, tailFormItemLayout } from '../../app'
import { history } from '../../../store'
import './index.css'
import { noteTypes } from '../list/Schedule'
import { func } from '../../../modules/utils'

const FormItem = Form.Item
const { TextArea } = Input
const { Option } = Select
const timeFormat = 'HH:mm'
const dateFormat = 'DD/MM/YYYY'

const propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  getItem: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
  setItemState: PropTypes.func.isRequired,
  getClientList: PropTypes.func.isRequired,
  clearClientList: PropTypes.func.isRequired,
  noteId: PropTypes.string.isRequired,
  note: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  clientList: PropTypes.array.isRequired,
}

const NoteTitle = ({ input }) =>
  <Input
    placeholder='Title'
    value={input.value}
    onChange={e => input.onChange(e.target.value)}
  />
const Client = ({ input, clientList, handleSelect, handleSearch }) => {
  return (
    <Select
      mode='combobox'
      value={input.value}
      placeholder='Client'
      defaultActiveFirstOption={false}
      showArrow={false}
      filterOption={false}
      onSelect={e => {input.onChange(clientList.find(c => c._id === e).fullName); handleSelect(e)}}
      onSearch={e => {input.onChange(e); handleSearch(e)}}
    >
      {clientList.map(d => (
        <Option key={d._id}>{d.fullName}</Option>
      ))}
    </Select>
  )
}
const Description = ({ input }) =>
  <TextArea
    placeholder='Description'
    autosize={{ minRows: 1, maxRows: 99 }}
    value={input.value}
    onChange={e => input.onChange(e.target.value)}
  />
const NoteType = ({ input }) =>
  <Select
    value={input.value}
    onChange={input.onChange}
  >
    {noteTypes.map(type => (
      <Option value={type.id} key={type.id}>
        <Icon type={type.icon} />
        {' '}
        {type.title}
      </Option>
    ))}
  </Select>
const Date = ({ input }) =>
  <DatePicker
    format={dateFormat}
    placeholder='Please select date!'
    value={input.value}
    onChange={input.onChange}
  />
const Time = ({ input }) =>
  <TimePicker
    value={input.value}
    format={timeFormat}
    placeholder='Please select time!'
    onChange={input.onChange}
  />
const confirm = (func) => {
  Modal.confirm({
    title: 'Confirm',
    content: 'Are you sure you want to delete note?',
    okText: 'Yes',
    okType: 'danger',
    cancelText: 'No',
    onOk() {
      func().then(() => history.push('/schedule'))
    },
  });
}

export class Note extends Component {
  constructor(props) {
    super(props)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.renderClientInput = this.renderClientInput.bind(this)
    this.search = func.debounce(props.getClientList, 1000)
  }

  componentDidMount() {
    const { noteId, getItem, location, change } = this.props
    if (noteId !== 'new') {
      return getItem(noteId)
    }
    const parsed = queryString.parse(location.search)
    const { clientFullName, clientId } = parsed
    if (clientFullName && clientId) {
      change('clientFullName', clientFullName)
      change('clientId', clientId)
    }
  }

  componentWillUnmount() {
    const { setItemState, clearClientList } = this.props
    setItemState()
    clearClientList()
  }

  handleSearch(val) {
    const { location, noteId, change } = this.props
    const parsed = queryString.parse(location.search)
    val ? parsed.search = val : delete parsed.search
    history.push({
      pathname: `/schedule/${noteId}`,
      search: queryString.stringify(parsed)
    })
    if (val.length > 2) {
      return this.search()
    }
    if (!val.length) {
      change('clientId', '')
    }
  }

  handleSelect(clientId) {
    this.props.change('clientId', clientId)
  }

  renderClientInput(e) {
    return (
      <Client
        {...e}
        clientList={this.props.clientList}
        handleSelect={this.handleSelect}
        handleSearch={this.handleSearch}
      />
    )
  }

  render() {
    const { noteId, removeItem, handleSubmit } = this.props
    return (
      <div className='note'>
        <div className={'title'}>
          {noteId === 'new' ?
            <h2>Add new note</h2> : null
          }
        </div>
        <Form onSubmit={handleSubmit}>
          <FormItem
            {...formItemLayout}
            label='Date'
          >
            <Field
              name='date'
              component={Date}
            />
          </FormItem>
          <FormItem
            {...formItemLayout}
            label='Time'
          >
            <Field
              name='date'
              component={Time}
            />
          </FormItem>
          <FormItem
            {...formItemLayout}
            label='Type'
          >
            <Field
              name='noteType'
              component={NoteType}
            />
          </FormItem>
          <FormItem
            {...formItemLayout}
            label='Title'
          >
            <Field
              name='noteTitle'
              component={NoteTitle}
            />
          </FormItem>
          <FormItem
            {...formItemLayout}
            label='Description'
          >
            <Field
              name='description'
              component={Description}
            />
          </FormItem>
          <FormItem
            {...formItemLayout}
            label='Client'
          >
            <Field
              name='clientFullName'
              component={this.renderClientInput}
            />
          </FormItem>
          <FormItem
            {...formItemLayout}
          >
            <Field
              name='clientId'
              component={() => <span />}
            />
          </FormItem>

          <FormItem {...tailFormItemLayout} className={'form-buttons'}>
            <Button onClick={() => history.push('/schedule')}>Cancel</Button>
            {' '}
            {noteId !== 'new' ?
              <Button type='danger' onClick={() => confirm(() => removeItem(noteId))}>
                Delete
              </Button> : null
            }
            {' '}
            <Button type='primary' htmlType='submit'>{noteId === 'new' ? 'Create' : 'Save'}</Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

Note.propTypes = propTypes
export default Note



// WEBPACK FOOTER //
// ./src/containers/schedule/note/Note.js